import {
  Component,
  AfterViewInit,
  OnInit,
  ChangeDetectorRef,
  AfterViewChecked,
} from "@angular/core";
import {
  Router,
  NavigationStart,
  NavigationCancel,
  NavigationEnd,
} from "@angular/router";
import { VersionCheckService } from "./services/check-version/version-check.service";
import { environment } from "./../environments/environment";
import { ApiService } from "./services/api";
import { AngularFireDatabase } from "angularfire2/database";

@Component({
  // tslint:disable-next-line
  selector: "body",
  templateUrl: "./app.component.html",
})
export class AppComponent implements AfterViewInit, OnInit {
  loading;

  constructor(
    private router: Router,
    private check: VersionCheckService,
    private cdRef: ChangeDetectorRef,
    private firebaseDatabase: AngularFireDatabase
  ) {
    this.loading = true;
  }
  ngOnInit(): void {
    this.check.initVersionCheck("https://www.golfhubber.com/admin/");
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel
      ) {
        this.loading = false;
      }
    });

    // setTimeout(() => {
    //   this.firebaseDatabase
    //     .object(`/currentVersion/cms_black_theme`)
    //     .subscribe((data) => {
    //       let version = data.$value;
    //       if (version && version != environment.version) {
    //         location.reload();
    //       }
    //     });
    // }, 5000);
  }
  ngAfterViewInit() {}
}
